/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import {
    registerLoginService
} from "@ef/feature-login";

import {
    OauthRedirectLoginService
} from "@ef/backend-core";

import { ControllerRegistry } from "@ef/common-api";
import { RestApiDataController } from "@ef/backend-api";

import { 
    LetterTemplate,
    LetterTemplateApiController
} from "@ef/feature-lettertemplate";

export type LoginConfig = { apiurl?: string, loginurl?: string };

export async function initLogin({ apiurl, loginurl }: LoginConfig) {
    const theApiUrl = apiurl || (
        typeof process != "undefined" ? process?.env.APISERVER_URL : ""
    ) || "";

    if (!loginurl) {
        throw new Error("loginurl is required to initialize the login service");
    }

    registerLoginService(new OauthRedirectLoginService(theApiUrl, loginurl));
}

export function initControllers() {
    ControllerRegistry.set(
        "lettertemplates",
        (user) => new RestApiDataController<LetterTemplate>(user, "/lettertemplates", "v3")
    );

    ControllerRegistry.set(
        "letterTemplateApi",
        (user) => new LetterTemplateApiController(user)
    );

}
